export const getHexColor = (color) => {
  const ctx = document.createElement('canvas').getContext('2d');
  ctx.fillStyle = color;
  return ctx.fillStyle;
};

export const getTextColorByBackgroundColor = (color) => {
  const hexColor = getHexColor(color);
  const rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexColor);
  const r = rgb[0] & 0xff;
  const g = rgb[1] & 0xff;
  const b = rgb[2] & 0xff;
  const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return luma < 127.5 ? 'white' : 'black';
};
